import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center">
        <h1 className="text-8xl font-bold text-gray-300 mb-4">500</h1>
        <p className="text-2xl font-semibold text-gray-700 mb-2">サーバーエラーが発生しました</p>
        <p className="text-gray-500 mb-8">
          現在、サーバーに接続できません。しばらくしてから再試行してください。
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-2 text-white bg-blue-500 hover:bg-blue-600 rounded-lg shadow-md transition duration-200"
        >
          ホームへ戻る
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
